import Constants from "expo-constants";

export const appConfig = {
    pocketbaseUrl: process.env.EXPO_PUBLIC_POCKETBASE_URL,
    apiUrl: process.env.EXPO_PUBLIC_BACKEND_URL,
    chatUrl: process.env.EXPO_PUBLIC_CHAT_URL,
    allowedImpersonations: (process.env.EXPO_PUBLIC_ALLOWED_IMPERSONATIONS || '').split(',').filter((_) => _),
    webappUrl: process.env.EXPO_PUBLIC_WEBAPP_URL,
    dashboardUrl: process.env.EXPO_PUBLIC_DASHBOARD_URL,
    sentryDsn: process.env.EXPO_PUBLIC_SENTRY_DSN,
    sentryRelease: `${Constants.expoConfig?.slug ?? "octahub"}@${Constants.expoConfig?.version ?? "0.0.0"}`,
    appDataPersistence: {
        maxAge: 1000 * 60 * 60 * 24 * 21, // 21 days
        gcTime: 1000 * 60 * 60 * 24 * 21, // 21 days
        dataVersion: 2, // Increment this to invalidate all cached data, e.g. when the app data structure changes
        staleTime: 5 * 60 * 1000
    }
}
